export const numberFormats = {
  en_GB: {
    currency: {
      style: 'currency',
      currency: 'GBP',
    },
  },
} as const;
